import React from 'react'

export default function PlaceHolder() {
  return (
    <div>
      Place Holder Page
    </div>
  )
}